export default __webpack_public_path__ + "static/media/pokemon_trainer2.44e3e999.jpg";